import { useState, useEffect } from "react"
import {
  isLatLngQueryString,
  createGeolocationFeature,
} from "utils/geolocation"
import { useNormalizedRouterSearchParams } from "./useNormalizedRouterSearchParams"
import {
  get as getPersistValue,
  set as setPersistValue,
} from "utils/persist_store"
import { useKioskConfig } from "providers/venue/modules/data/kiosk-config/useKioskConfig"

const VENUE_DEVICE_LOCATION_KEY = "venue_device_location"
const VENUE_DEVICE_NAME = "venue_device_name"

export const useDeviceLocation = () => {
  const [deviceLocationState, setDeviceLocationState] = useState(null)
  const [deviceLocationNameState, setDeviceLocationNameState] = useState(null)

  // NOTE: `deviceLocation` and `locationName` query strings will act as fallbacks for kiosk config if it doesn't exist.
  const {
    deviceLocation: fallbackDeviceLocation,
    locationName: fallbackLocationName,
  } = useNormalizedRouterSearchParams()

  const { kioskConfig } = useKioskConfig()
  const {
    deviceLocation = fallbackDeviceLocation,
    locationName = fallbackLocationName,
  } = kioskConfig

  useEffect(() => {
    const locationPath = getPersistValue(VENUE_DEVICE_LOCATION_KEY)
    const locationName = getPersistValue(VENUE_DEVICE_NAME)
    setDeviceLocationState(
      createGeolocationFeature(locationPath, {
        name: "Your Location",
      })
    )
    setDeviceLocationNameState(locationName)
  }, [])

  useEffect(() => {
    if (deviceLocation && isLatLngQueryString(deviceLocation)) {
      setPersistValue(VENUE_DEVICE_LOCATION_KEY, deviceLocation)
      setDeviceLocationState(
        createGeolocationFeature(getPersistValue(VENUE_DEVICE_LOCATION_KEY), {
          name: "Your Location",
        })
      )
    }
  }, [deviceLocation, locationName])

  useEffect(() => {
    //TODO finding a better position for setPersistValue VENUE_DEVICE_NAME
    if (locationName) {
      setPersistValue(VENUE_DEVICE_NAME, locationName)
      setDeviceLocationNameState(locationName)
    }
  }, [locationName])

  return {
    deviceLocation: deviceLocationState,
    deviceLocationName: deviceLocationNameState,
  }
}
